import request from '@/utils/request'

/**
 * 机器人工作总结API
 */

// 分页获取机器人的工作总结列表
export function getSummaryList(robotId, params = {}) {
  return request({
    url: `/robot-summary/robot/${robotId}/page`,
    method: 'get',
    params: {
      page: params.page || 1,
      page_size: params.page_size || 20,
      summary_type: params.summary_type
    }
  })
}

// 获取工作总结详情
export function getSummaryDetail(id) {
  return request({
    url: `/robot-summary/${id}`,
    method: 'get'
  })
}

// 创建工作总结
export function createSummary(data) {
  return request({
    url: '/robot-summary',
    method: 'post',
    data
  })
}

// 更新工作总结
export function updateSummary(id, data) {
  return request({
    url: `/robot-summary/${id}`,
    method: 'put',
    data
  })
}

// 删除工作总结
export function deleteSummary(id) {
  return request({
    url: `/robot-summary/${id}`,
    method: 'delete'
  })
}

// 检查工作总结是否存在
export function checkSummaryExists(params) {
  return request({
    url: '/robot-summary/check-exists',
    method: 'get',
    params
  })
}

// 按类型获取机器人的工作总结列表
export function getSummaryListByType(robotId, summaryType) {
  return request({
    url: `/robot-summary/robot/${robotId}`,
    method: 'get',
    params: { summary_type: summaryType }
  })
}

// 获取机器人最近的总结列表
export function getLatestSummaries(robotId, summaryType, limit = 10) {
  return request({
    url: `/robot-summary/robot/${robotId}/latest`,
    method: 'get',
    params: { summary_type: summaryType, limit }
  })
}

// 根据日期获取工作总结
export function getSummaryByDate(params) {
  return request({
    url: '/robot-summary/by-date',
    method: 'get',
    params
  })
}

// 获取当前用户所有机器人的工作总结列表（分页）
export function getMySummaryList(params = {}) {
  return request({
    url: '/robot-summary/list/me',
    method: 'get',
    params: {
      page: params.page || 1,
      page_size: params.page_size || 20,
      summary_type: params.summary_type,
      start_date: params.start_date,
      end_date: params.end_date
    }
  })
}

export default {
  getSummaryList,
  getSummaryDetail,
  createSummary,
  updateSummary,
  deleteSummary,
  checkSummaryExists,
  getSummaryListByType,
  getLatestSummaries,
  getSummaryByDate,
  getMySummaryList
}
